import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LazyImgModule } from '@core-mkt/services/lazy-load/lazy-load.module';
import { QueryParamModule } from '@core-mkt/services/query-param/query-param.module';
import { VisionButtonModule } from '@core-mkt/shared/components/vision-button/vision-button.module';
import { CustomDecimalModule } from '@ecom/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { PricingTableComponent } from './pricing-table/pricing-table.component';

@NgModule({
  exports: [PricingTableComponent],
  imports: [
    CommonModule,
    QueryParamModule,
    LazyImgModule,
    FontAwesomeModule,
    CustomDecimalModule,
    VisionButtonModule,
    PricingTableComponent,
  ],
})
export class PricingTableModule {}
